import script from "./ForceOrientation.vue?vue&type=script&lang=js"
export * from "./ForceOrientation.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__